export const defaultGrid = {
    containLabel: true,
    left: '25px', // small padding
    right: '25px', // small padding
    top: '70px', // pixels from top (makes room for legend)
    bottom: '30px', // pixels from bottom (makes room for x-axis)
} as const;

export const defaultAxisLabelGap = 20;
